<template>
  <VeeForm ref="form" @submit="save">
    <fieldset>
      <QInput
        v-model="comment"
        filled
        stack-label
        :label="formLabel || $t('ETAB.FORMS.PLACEHOLDERS.@RECRUITMENT_FEEDBACK')"
        type="textarea"
        counter
        :maxlength="MEDIUM_TEXT_LENGTH_LIMIT"
        class="q-my-lg"
      />
    </fieldset>

    <div class="q-py-md text-center">
      <QBtn type="submit" no-caps class="btn-candidates btn-large" :label="$t('ETAB.PAGES.RECRUITMENT.FEEDBACK_FORM.@SEND')" color="secondary" />
    </div>
  </VeeForm>
</template>

<script>
  import { MEDIUM_TEXT_LENGTH_LIMIT } from "@core/constants";
  import { Form as VeeForm } from "vee-validate";

  export default {
    components: {
      VeeForm,
    },
    props: {
      formLabel: {
        type: String,
        default: () => "",
      },
    },
    emits: ["save"],
    data() {
      return {
        comment: "",
      };
    },
    created() {
      this.MEDIUM_TEXT_LENGTH_LIMIT = MEDIUM_TEXT_LENGTH_LIMIT;
    },
    methods: {
      save() {
        const { comment } = this;
        this.$emit("save", { comment });
      },
    },
  };
</script>
